__turbopack_context__.v({
  "chevron": "_711fga_chevron",
  "description": "_711fga_description",
  "nameAndCapacity": "_711fga_nameAndCapacity",
  "roomType": "_711fga_roomType" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "sheetContent": "_711fga_sheetContent",
});
